/**
 * Created by mac on 12/23/20
 */

const ResourceCollectible = function (unit) {
    UnitComponent.call(this, unit);

    if (typeof unit.getData().resourceCollectible === "object") {
        this.targetType = unit.getData().resourceCollectible.targetType;
    }
};

ResourceCollectible.prototype = Object.create(UnitComponent.prototype);
ResourceCollectible.prototype.constructor = ResourceCollectible;

ResourceCollectible.prototype.onCollection = function (index, target, duration) {
    if (this.view) {
        this.view.collectionAnimation(index, target, duration);
    } 
};

ResourceCollectible.prototype.handleClick = function () {
    const target = this.getResourceTarget();
    if (!target) {
        return false;
    }

    this.collect(target);
    return true;
};

ResourceCollectible.prototype.getResourceTarget = function () {
    const units = Map2d.currentMap.listAvailableUnits(this.targetType ? { type: this.targetType } : { code: this.unit.code });

    for (let i = 0; i < units.length; i++) {
        const upgradable = units[i].findComponent(Upgradable);
        if (upgradable && upgradable.canCollect(this.unit)) {
            return upgradable.unit;
        }
        if (upgradable && upgradable.canCollect(this.unit, { skipBuild: true })) {
            cleverapps.centerHint.createTextHint(Messages.get("cantCollectBuilding", { target: Messages.get(`Units.${upgradable.unit.code}.stage${upgradable.unit.stage + 1}.name`) }));
            return;
        }
    }
};

ResourceCollectible.prototype.collect = function (target) {
    this.unit.claimPoints();
    if (this.unit.findComponent(Pulsing)) {
        this.unit.findComponent(Pulsing).setRemoved(true);
    }
    const speed = 30; // cell/second
    const distance = Math.sqrt(Math.pow(target.x - this.unit.x, 2) + Math.pow(target.y - this.unit.y, 2));
    const duration = Math.max(0.5, distance / speed);

    this.onCollection(0, target, duration);

    cleverapps.effects.fire("ui.button.click");

    if (Map2d.currentMap.advice) {
        Map2d.currentMap.advice.boo();
    }

    if (target.isUpgradable()) {
        target.findComponent(Upgradable).incProgress(duration * 1000);
    }

    this.unit.remove(true);
};